import { render, staticRenderFns } from "./archi.vue?vue&type=template&id=7f6a9aec&scoped=true&"
import script from "./archi.vue?vue&type=script&lang=js&"
export * from "./archi.vue?vue&type=script&lang=js&"
import style0 from "./archi.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./archi.vue?vue&type=style&index=1&id=7f6a9aec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6a9aec",
  null
  
)

export default component.exports